import { bool, mixed, object, ObjectSchema, string } from 'yup';

import { DynamicCardAction, ActionCompleteProfile, ActionNavigateTo, ActionType } from './types';

export const CompeteProfileActionSchema: ObjectSchema<ActionCompleteProfile> = object({
  type: string<ActionType.RequestCompleteProfile>().required().oneOf([ActionType.RequestCompleteProfile]),
  payload: object({
    return_url: string().optional(),
  })
    .strict()
    .noUnknown(),
})
  .strict()
  .noUnknown();

export const ExternalLinkActionSchema: ObjectSchema<ActionNavigateTo> = object({
  type: string<ActionType.NavigateTo>().required().oneOf([ActionType.NavigateTo]),
  payload: object({
    url: string().required(),
    openURLInWebView: bool().strict().optional(),
  })
    .strict()
    .noUnknown()
    .required(),
})
  .strict()
  .noUnknown();

const isValidAction = (data: unknown): data is DynamicCardAction => {
  return [CompeteProfileActionSchema, ExternalLinkActionSchema].some((validation) => validation.isValidSync(data));
};
export const DynamicCardActionSchema = mixed<DynamicCardAction>().test(
  'isActionSupportedAndValid',
  'Action is not supported or invalid',
  isValidAction,
);
